import React, { useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import { ModalDialog } from "@culturehq/components";

import { Trans } from "app/utils";

import ChqModalDialog from "components/common/ChqModalDialog";
import Recognize from "./Recognize";

const RecognitionModal = ({ checkState = true, children }) => {
  const location = useLocation();

  const user = checkState && location.state && location.state.user;
  const initialUsers = user ? [user] : [];

  const [open, setOpen] = useState((location.hash === "#give") || user);
  const onOpen = useCallback(() => setOpen(true), [setOpen]);
  const onClose = useCallback(() => setOpen(false), [setOpen]);

  const onApproveCreate = useCallback(
    () => {
      onClose();
    },
    [onClose]
  );

  return (
    <>
      {children(onOpen)}
      {open && (
        <ChqModalDialog className="recognize" entrance="zoomIn" onClose={onClose}>
          <ModalDialog.Heading onClose={onClose}>
            <Trans>Recognize people at your organization</Trans>
          </ModalDialog.Heading>
          <ModalDialog.Body>
            <Recognize onCreate={onApproveCreate} initialUsers={initialUsers} />
          </ModalDialog.Body>
        </ChqModalDialog>
      )}
    </>
  );
};

export default RecognitionModal;
